import { render, staticRenderFns } from "./detailMsg.vue?vue&type=template&id=644374a2&scoped=true&"
import script from "./detailMsg.vue?vue&type=script&lang=js&"
export * from "./detailMsg.vue?vue&type=script&lang=js&"
import style0 from "./detailMsg.vue?vue&type=style&index=0&id=644374a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644374a2",
  null
  
)

export default component.exports